import {
    CSSProperties,
} from "react"

const styles: {[key: string]: CSSProperties} =
{
    content:
    {
        height: "fit-content",
        display: "flex",
        flexFlow: "column",
    },
    tabContentPane: {
        padding: "13px 21px 13px 34px",
    },
    navBarLogoStyle: 
    {
        height: "55px",
        margin: "-10px 0px",
    },
    tabBarBackground:
    {
        height: "100vh",
    },
    tabBarStyle:
    {
        backgroundColor: "#e9ebfa",
        width: "60px",
    },
    tabRow:
    {
        position: "relative",
        width: "100%",
    },
    tabLinkStyle:
    {
        borderRadius: 0,
    },
    tabBarWrapper:
    {
        height: "100%",
        width: "50px",
        backgroundColor: "grey"
    },
    tabContentWrapper:
    {
        position: "relative",
        height: "fit-content",
    }
}

export default styles